import { useEffect, useRef } from "react";
import { animate, useInView } from "framer-motion";

const CountUp = ({ to, decimals = 0, prefix = "", suffix = "", dark = false, testId }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  useEffect(() => {
    if (!inView || !ref.current) return;
    const controls = animate(0, to, {
      duration: 1.8,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => {
        if (ref.current) ref.current.textContent = `${prefix}${v.toFixed(decimals)}${suffix}`;
      },
    });
    return () => controls.stop();
  }, [inView, to, decimals, prefix, suffix]);
  return (
    <span ref={ref} data-testid={testId || `counter-${to}`} className={dark ? "text-white" : ""}>
      {prefix}0{suffix}
    </span>
  );
};

export default CountUp;
